import React from "react";
import { motion } from "framer-motion";

export const SectionHeader = ({ eyebrow, title, subtitle, align = "center" }) => {
  const wrapper = align === "left" ? "text-left items-start max-w-3xl" : "text-center items-center max-w-3xl mx-auto";
  return (
    <div className={`flex flex-col gap-5 ${wrapper}`}>
      {eyebrow && (
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5 }}
          className="eyebrow"
        >
          {eyebrow}
        </motion.div>
      )}
      <motion.h2
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6 }}
        className="heading-serif text-4xl sm:text-5xl lg:text-[3.75rem] font-medium tracking-tight text-brand-navyDark leading-[1.06]"
      >
        {title}
      </motion.h2>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="text-[16px] text-brand-body leading-[1.8]"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
};
